import { Component, h, Prop } from '@stencil/core';
import Icon from '../svg/plus.svg'

@Component({
  tag: 'cr-icon-plus',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrIconPlus {

  /**
   * The size of the icon - can be 'small', 'medium' or 'large'
   */
  @Prop() size: string

  render() {

    return (
      <div
        class={this.size}
        innerHTML={Icon}
      />
    );
  }

}
